{
  "name": "Hypérion",
  "version": "0.10.0",
  "gitVersion": "d74c0ab (21/10/2026)",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "serve:ssr:hyperion": "node dist/hyperion/server/server.mjs",
    "test:e2e": "node e2e/interventions-review.cjs",
    "test:e2e:non-admin": "node e2e/non-admin-review.cjs"
  },
  "private": true,
  "packageManager": "npm@11.16.1",
  "dependencies": {
    "@amcharts/amcharts5": "^5.17.2",
    "@amcharts/amcharts5-fonts": "^5.0.1",
    "@amcharts/amcharts5-geodata": "^5.1.5",
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.1.6",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/material": "^22.1.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@angular/ssr": "^22.1.0",
    "@auth0/angular-jwt": "^5.2.0",
    "ang-jsoneditor": "^6.0.0",
    "express": "^5.1.0",
    "jsoneditor": "^10.4.3",
    "leaflet": "^1.9.4",
    "maplibre-gl": "^5.24.0",
    "material-symbols": "^0.44.12",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.1.0",
    "@angular/cli": "^22.1.0",
    "@angular/compiler-cli": "^22.1.0",
    "@types/express": "^5.0.1",
    "@types/leaflet": "^1.9.21",
    "@types/node": "^20.17.19",
    "axe-core": "4.14.0",
    "jsdom": "^28.0.0",
    "playwright": "1.62.1",
    "prettier": "^3.8.1",
    "typescript": "~6.0.3",
    "vitest": "^4.0.8"
  },
  "allowScripts": {
    "@parcel/watcher": true,
    "esbuild": true,
    "lmdb": true,
    "msgpackr-extract": true,
    "ws@0.4.32": true
  }
}
